module.exports = __webpack_public_path__ + "img/act2_img_mao@2x.5053a1ff.png";